const CircularPlus = ({ ...props }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.6452 8.78226V9.21774C13.6452 9.45726 13.4492 9.65323 13.2097 9.65323H9.65323V13.2097C9.65323 13.4492 9.45726 13.6452 9.21774 13.6452H8.78226C8.54274 13.6452 8.34677 13.4492 8.34677 13.2097V9.65323H4.79032C4.55081 9.65323 4.35484 9.45726 4.35484 9.21774V8.78226C4.35484 8.54274 4.55081 8.34677 4.79032 8.34677H8.34677V4.79032C8.34677 4.55081 8.54274 4.35484 8.78226 4.35484H9.21774C9.45726 4.35484 9.65323 4.55081 9.65323 4.79032V8.34677H13.2097C13.4492 8.34677 13.6452 8.54274 13.6452 8.78226ZM18 9C18 13.9718 13.9718 18 9 18C4.02823 18 0 13.9718 0 9C0 4.02823 4.02823 0 9 0C13.9718 0 18 4.02823 18 9ZM16.8387 9C16.8387 4.64879 13.3077 1.16129 9 1.16129C4.64879 1.16129 1.16129 4.69234 1.16129 9C1.16129 13.3512 4.69234 16.8387 9 16.8387C13.3512 16.8387 16.8387 13.3077 16.8387 9Z"
        fill="#646464"
      />
    </svg>
  )
}

export default CircularPlus
